var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSymposium)?_c('div',{staticClass:"wrap-banner"},[_c('Logo'),_c('Carousel')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }